// src/components/InitiativesSection.jsx
import React from 'react';
import initiative1 from '../assets/images/Agri.jpg';
import initiative2 from '../assets/images/Sust.jpg';
import initiative3 from '../assets/images/Trace.jpg';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';

const InitiativesSection = () => {
  const initiatives = [
    {
      title: "OUR INITIATIVES",
      image: initiative1,
      description: "With our own farms, we work closely with farmers using traditional practices and produce products with integrity, valuing quality over profit.",
      link: "/initiative/our-initiative"
    }
    // ,
    // {
    //     title: "Sustainability",
    //     image: initiative2,
    //     description: "Farm Sustainable Assessment is an initiative by Sustainable Agriculture Initiative (SAI) Platform. This platform includes all food chai",
    //     link: "/initiative/sustainability"
    //   },
    //   {
    //     title: "Traceability",
    //     image: initiative3,
    //     description: "Smart Farm Application is a cloud-based system, which takes an integrated and analytical approach to farming.",
    //     link: "/initiative/traceability"
    //   }
    // Add other initiatives similarly
  ];

  return (
    <section className="page-content grey">
      <div className="container" style={{ marginTop: '10px' }}>
        <div className="row">
          <div className="section-header text-center">
            <h3>Initiatives</h3>
          </div>
          <div className="row no-padding">
            {initiatives.map((item, index) => (
              <div className="each-card col-lg-12 col-md-12 col-sm-12" key={index}>
                <Link  className="slider-card">
                  <div className="slider-card-image col-lg-6" style={{paddingLeft:"0px"}}>
                    <img alt="Sustainable Agri Initiatives" src={item.image} />
                  </div>
                  <div className="slider-card-description col-lg-6" style={{paddingTop:"70px",paddingLeft:"30px"}}>
                     <h2 style={{color:'var(--brand-gold-light)', fontFamily:'var(--brand-heading-font)'}}>{item.title}</h2>
                      <h6 style={{color:"var(--brand-gold)",fontSize:"larger"}}> UTMOST CARE FROM PLANT TO PACKAGE </h6>
                      <p className="text-justify">{item.description}</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InitiativesSection;